import { getMessage } from '@tcc/i18n';
import Card from '../cardAndPreview/Card';
import styles from './Scouting.css';

export const NoActivities = () => (
    <Card title={getMessage('card.activities')}>
      <div className={styles.emptyActivities} data-test-id="no-activities">
        {getMessage('card.noActivities')}
      </div>
    </Card>
  )
